import * as S from "./styles.ts";
import { LinkGroup, TLink } from "../LinkGroup";

export type TLinkCategory = {
  title: string;
  links: TLink[];
};

interface IInternalLinksProps {
  internalLinks: TLinkCategory[];
}

const InternalLinks = ({ internalLinks }: IInternalLinksProps) => {
  return (
    <S.LinkColumn>
      {internalLinks.map((section, index) => (
        <S.Section key={index}>
          <S.SectionTitle>{section.title}</S.SectionTitle>
          <LinkGroup links={section.links} />
        </S.Section>
      ))}
    </S.LinkColumn>
  );
};

export default InternalLinks;
